import { Tree } from 'primereact/tree';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import { useState, useEffect, useRef } from 'react';
import { Dialog } from '@mui/material';
import {
  Button,
  DialogActions,
  DialogContent,
} from '@mui/material';

import { fetchAPI } from '../../../api/GenericFetch.js';
import { GET_ROLE_MAPPING_FUNCTION_URL } from '../../../const/APIUrl.js';
import { useUpdateMutation  } from '../../../hooks/APIRequestHook.tsx';
import { queryRoleMappingCacheKey as cacheKey } from  '../../../const/QueryCacheKey.js';
import { RoleFunctionModel, RequestRoleFunctionModel } from '../../../models/RoleModel.tsx';
import { BaseRequestAPIModel, RequestAPIUrlModel } from '../../../models/BaseRequestModel.tsx';
import { BlockUI, AlertMessage, DialogMessage } from '../../Utility.jsx';
import { BaseEntity } from '../../../models/BaseEntity.tsx';
import { setDelay } from  '../../../helpers/UI.js';

export default function RoleFunctionTree({roleId, isOpen, handleClose})
{
    const { mutateAsync: updateRoleFunction, isPending: isUpdating } = useUpdateMutation<RequestRoleFunctionModel<BaseEntity>>({cacheKey, skipOptimisticUpdate:true});
    const [ selectedKeys, setSelectedKeys] = useState({});    
    const [ data, setData] = useState([]);
    const [ showDialog, setShowDialog] = useState(false);

    const handleSubmit = async () => {
        setShowDialog(true);        
        let roleFunction = [{} as RoleFunctionModel];
        roleFunction = [];
        for (const key in selectedKeys) {
            let splitKey = key.split('-')
            let pageId = parseInt(splitKey[0]);
            let functionId = parseInt(splitKey[1]);
            if (splitKey.length == 1 || !selectedKeys[key].checked) continue;
            const newData = new RoleFunctionModel(roleId, pageId, functionId);
            roleFunction.push(newData);
        }
        
        const request = new BaseRequestAPIModel<RequestRoleFunctionModel<BaseEntity>>({ Id : roleId, RoleFunction : roleFunction },  {} as any, { url: GET_ROLE_MAPPING_FUNCTION_URL } as RequestAPIUrlModel);
        let response = await updateRoleFunction(request);

        if (response.isSuccess) {      
            //close this dialog
            setDelay().then(() => {    
                setShowDialog(false);
                handleClose();
            });
        }
    };

    useEffect(() => {
         const fetchData = async () => {
            const response = await fetchAPI({url:GET_ROLE_MAPPING_FUNCTION_URL, method: 'POST', body : { Id : roleId }});
            setData(response.data);

            let checkedKeys = {};
            response.data.map(d => {
                checkedKeys[d.key] = { checked: d.selected, partialChecked: d.selected};
                d.children.map(dChild => {
                    checkedKeys[dChild.key] = { checked: dChild.selected};
                })
            });

            setSelectedKeys(checkedKeys);
        };        

        fetchData();
    }, []);

    return (
        <>
            { isUpdating && <BlockUI />}
            { showDialog && <DialogMessage message='Data successfully saved'/>}
            <Dialog open={isOpen} className="mui-dialog-custom p-1">
                <div className="row p-3">
                    <div className="form-group mb-3">
                        <Tree value={data} selectionMode="checkbox" selectionKeys={selectedKeys} 
                            onSelectionChange={(e) => setSelectedKeys(e.value)} className="p-0" />
                    </div>
                    <div className="form-group text-end">
                        <Button className="col-lg-2 col-md-12 col-12" onClick={handleClose}>Cancel</Button>
                        <Button className="col-lg-2 col-md-12 col-12" onClick={handleSubmit} variant="contained" disabled={isUpdating}>Save</Button> 
                    </div>
                </div>
            </Dialog>
        </>
    );
}